import React, { FC } from 'react'
import block from 'bem-cn'

import './Skeleton.scss'

const b = block('skeleton')

export enum SkeletonVariant {
  LIGHT = 'light',
  DARK = 'dark',
  BLACK = 'black'
}

export type SkeletonProps = {
  className?: string
  variant?: SkeletonVariant
}

export const Skeleton: FC<SkeletonProps> = ({ className, variant }) => (
  <div className={b('wrapper').mix(className, variant)} />
)
